import React, { createContext, useContext } from 'react';
import { ConfirmModal, DialogBox } from '@mummssoftware/common-ui';
import defaults from '../../../translations/en.json';

export const DiscardModalContext = createContext({
  open: false,
  setOpen: null,
});

export const DiscardModal = ({ onConfirm }) => {
  const { open, setOpen } = useContext(DiscardModalContext);
  return (
    <>
      <DialogBox open={open} maxWidth="xl" handleClick={() => setOpen(false)}>
        <ConfirmModal
          onOKClick={() => {
            onConfirm();
            setOpen(false);
          }}
          onCancelClick={() => setOpen(false)}
          okText={defaults.DISCARD}
          noText={defaults.CANCEL}
          modalText={defaults.confirmDiscard}
        />
      </DialogBox>
    </>
  );
};
